import React from 'react';
import * as ReactDOM from 'react-dom';
import { Icon, Steps } from 'antd-mobile';
import { ClockCircleFill } from 'antd-mobile-icons';
import {post} from '../../utils/request';
import api from './api';

import './index.less';
import { getUrlParam } from '../../utils/util';

const { Step } = Steps

class WithdrawalRecords extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            data: []
        };
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.init()
    }

    init(){
        this.getData();
    }

    getData(){
        console.log(getUrlParam('gmtCreate'))
    }

    render() {
        const {data, urlOps} = this.state;
        
        return (
            <div style={{ background: '#F3F4F5', height: document.documentElement.clientHeight }}>     
                <div style={{ background: '#fff' }}>
                <div style={{ height: '0.3rem' }}></div> 
                 <div className='resultIcon' style={{ marginBottom: '0.16rem' }}>{getUrlParam('status')=='0'?<ClockCircleFill style={{ height: '0.44rem', width: '0.44rem', color: '#009F90'}} />:(getUrlParam('status')=='1'?<Icon type='check-circle' style={{ height: '0.44rem', width: '0.44rem'}} />:<Icon type='cross-circle-o' style={{ height: '0.44rem', width: '0.44rem', color: '#FE3824'}} />)}</div>
                 <p className='status'>{getUrlParam('status')=='0'?'申请已提交':(getUrlParam('status')=='1'?'已到账':'提现失败')}</p>
                 <Steps
                    direction='vertical'
                    current={1}
                    style={{ marginLeft: '0.22rem', marginTop: '0.48rem' }}
                    className='step'
                    >
                    <Step
                        title={<div><span>提现申请已提交{getUrlParam('cashOutType')=='2'?'':'，等待打款处理'}</span><div style={{ fontSize:'0.12rem', color: '#999999', fontFamily: 'PingFangSC-Regular, PingFang SC',fontWeight: 400 }}>{getUrlParam('gmtCreate')}</div></div>}
                        icon={<div className='circle'></div>}
                    />
                    <Step
                        title={getUrlParam('status')=='-1'?<span style={{ color: '#FE3824' }}>提现失败</span>:(getUrlParam('cashOutType')=='2'?'预计在当天内到账':'预计在15天内到账')}
                        icon={getUrlParam('status')=='0'?<div className='circle disabled'></div>:getUrlParam('status')=='1'?<div className='circle'></div>:<div className='circle error'></div>}
                    />
                </Steps>
                </div> 
                <div style={{ marginTop: '0.08rem', background: '#fff' }}>
                    <div style={{ height: '0.1rem' }} />
                    <div className='list-item'><span className='left'>申请金额</span><span className='right'>{getUrlParam('cashOutAmount')}元</span></div>
                    {getUrlParam('cashOutType')=='2'?<div className='list-item'><span className='left'>到账金额</span><span className='right'>{getUrlParam('actualAmount')}元</span></div>:''}
                    <div className='list-item'><span className='left'>转出方式</span><span className='right'>{getUrlParam('cashOutType')=='2'?'转出到充电卡':'转出到银行卡'}</span></div>
                    <div className='list-item'><span className='left'>转入账户</span><span className='right'>{getUrlParam('cashOutType')=='2'?getUrlParam('phoneNumber'):getUrlParam('bankAccount')}</span></div>
                    <div className='list-item'><span className='left'>订单号</span><span className='right'>{getUrlParam('cashNunmber')}</span></div>
                    <div style={{ height: '0.08rem' }} />
                </div>
            </div>
        );
    }
}
export default WithdrawalRecords;


// WEBPACK FOOTER //
// ./src/withdrawalRecordsList/index/record.js